import { render, staticRenderFns } from "./TransacoesFinanceiras.vue?vue&type=template&id=56d8d785"
import script from "./TransacoesFinanceiras.vue?vue&type=script&lang=js"
export * from "./TransacoesFinanceiras.vue?vue&type=script&lang=js"
import style0 from "./TransacoesFinanceiras.vue?vue&type=style&index=0&id=56d8d785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports